module.exports = __webpack_public_path__ + "assets/img/c65443f796fe797f5f0dc274124dad1a.png";